import "./AssignEntityUserLocationComponent.scss";
import ButtonComponent from "../core/button/ButtonComponent";
import DialogComponent from "../dialog/dialogComponent";
import React, {useCallback, useEffect, useRef, useState} from "react";
import {APIConfig} from "../../../constants";
import useFetch from "../../hooks/useFetch";
import * as Yup from "yup";
import {Formik, Form, FormikProps, Field, FieldProps, FormikHelpers} from "formik";
import FormikSelectDropdownComponent from "../core/formik-select-dropdown/FormikSelectDropdownComponent";
import {isEqual} from "lodash";

interface AssignEntityUserLocationComponentProps {
    entityType: "labId" | "facilityId",
    isOpen: boolean,
    entityId: string | number,
    onClose: Function,
    onUpdate: Function,
    assignedLocation: any[],
}

const locationValidationSchema = Yup.object({
    locationIds: Yup.array()
        .of(Yup.number().required('Location ID is required'))
        .required('Location IDs are required')
        .min(1, 'At least one Location ID is required'),
})

interface locationValidationType {
    locationIds: number[]
}

const locationFormikValues: locationValidationType = {
    locationIds: []
}
const AssignEntityUserLocationComponent = (props: AssignEntityUserLocationComponentProps) => {
    const {entityType, isOpen, entityId, onClose, onUpdate, assignedLocation} = props;
    const [locationFormValues, setLocationFormValues] = useState<locationValidationType>(locationFormikValues);
    const formikRef = useRef<FormikProps<any>>(null);

    const {response: locationListDropdown = [], fetchData: fetchLocationList} = useFetch<any>();


    const getLocationDropdownList = useCallback(() => {
        fetchLocationList({
            url: APIConfig.GET_ENTITY_LINKED_LOCATIONS.URL,
            method: APIConfig.GET_ENTITY_LINKED_LOCATIONS.METHOD,
            payload: {
                [entityType]: entityId
            }
        })
    }, [entityId, entityType, fetchLocationList])

    const onFormSubmit = useCallback((values: any, {setSubmitting, setErrors}: FormikHelpers<any>) => {
        onUpdate(values)
    }, [onUpdate]);

    useEffect(() => {
        getLocationDropdownList();
    }, [getLocationDropdownList]);

    useEffect(() => {
        setLocationFormValues({
            locationIds: assignedLocation.map((location) => location.id)
        })
    }, [assignedLocation]);
    return (
        <div className={'assign-entity-user-location-component'}>
            <DialogComponent
                open={isOpen}
                direction={"down"}
                title={"Assign User Location"}
                // description={"Description"}
                isShowCancel={false}
                maxWidth={'sm'}
            >
                <Formik
                    initialValues={locationFormValues}
                    validationSchema={locationValidationSchema}
                    validateOnChange={false}
                    validateOnBlur={true}
                    innerRef={formikRef}
                    enableReinitialize={true}
                    validateOnMount={true}
                    onSubmit={onFormSubmit}
                >
                    {({isSubmitting, values, isValid, setFieldValue, validateForm, resetForm}) => {
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        useEffect(() => {
                            validateForm();
                        }, [validateForm, values]);
                        return (<Form noValidate>
                            <Field name={"locationIds"}>
                                {(field: FieldProps) => (
                                    <div className="pdd-top-5">
                                        <FormikSelectDropdownComponent
                                            label={"Location"}
                                            formikField={field}
                                            placeholder={"Search Location"}
                                            required={true}
                                            multiple={true}
                                            isDataLoaded={true}
                                            isDataLoadingFailed={false}
                                            isDataLoading={false}
                                            valueKey={"id"}
                                            options={locationListDropdown}
                                            getOptionLabel={(option => option.name)}
                                        />
                                    </div>
                                )}
                            </Field>
                            <div className={'select-lab-dialog-action-wrapper'}>
                                <ButtonComponent
                                    variant={'outlined'}
                                    color={'primary'}
                                    handleClick={onClose}
                                >
                                    Cancel
                                </ButtonComponent>
                                <ButtonComponent
                                    type={"submit"}
                                    isLoading={isSubmitting}
                                    variant={'contained'}
                                    color={'primary'}
                                    disabled={!isValid}
                                >
                                    Submit
                                </ButtonComponent>
                            </div>
                        </Form>)
                    }}
                </Formik>
            </DialogComponent>
        </div>
    );

};

// export default AssignEntityUserLocationComponent;

export default React.memo(AssignEntityUserLocationComponent, (prevProps: any, nextProps: any) => {
    return isEqual(prevProps, nextProps);
});
